module.exports = __webpack_public_path__ + "img/IMG_9913.f191841c.jpg";